// extracted by mini-css-extract-plugin
export default {"row-title-manage-org":"ManageOrganization_row-title-manage-org__bhxcp"};